import React from "react"

import { Box, useMediaQuery, useTheme } from "@mui/material"
import { styled } from "@mui/material/styles"

import { useTranslations } from "@cirrus/core/i18n"

export const MockExamLabel = () => {
  const { i18n } = useTranslations()
  const { breakpoints } = useTheme()
  const isMobile = useMediaQuery(breakpoints.down("sm"), { noSsr: true })

  return <StyledBox className={isMobile ? "mobile-mode" : ""}>
    {
      isMobile
        ? i18n("General:MockExamShort")
        : i18n("General:MockExam")
    }
  </StyledBox>
}

const StyledBox = styled(Box)({
  border: ".1rem solid #402E3D",
  background: "#39354A",
  color: "#fff",
  fontWeight: 700,
  padding: ".6rem 1.6rem",
  lineHeight: "1.8rem",
  borderRadius: ".2rem",
  fontSize: "1.4rem",
  maxHeight: "3.2rem",
  display: "flex",
  alignSelf: "center",

  "&.mobile-mode": {
    maxWidth: "7rem",
    overflow: "hidden"
  }
})
